import { API } from '.'
import { handleResponse } from '../helpers';
import { API_URL } from '../config/appConfig';

const getTenantLogs = async (filterparams) => {
    return API.get(`${API_URL.auth}/system/events`, "system_logs", filterparams)
        .then(handleResponse)
}

export const tenantLogService = {
    getTenantLogs
};
